import { BaseComponent } from '../base-component'
import { CarouselComponent } from './carousel'
import { $el, $elParent, $list } from 'src/scripts/utils/utils'

const CAROUSEL_SELECTOR = 'carousel-component'
const DOTS_TRACK_SELECTOR = '[data-dots-track]'
const VISIBLE_DOTS_COUNT_ATTRIBUTE = 'dots-count'
const DOT_SELECTOR = '[data-dot-index]'
const DOT_ACTIVE_CLASS = '--active'
const CAN_SCROLL_CLASS = '--scrollable'

export class CarouselDynamicDots extends BaseComponent {
  track: HTMLElement
  _dots: HTMLElement[]
  visibleDotsCount: number
  sideDotsThreshold: number
  activeIndex: number
  dotWidth: number

  mountComponent(): void {
    this.activeIndex = 0

    this.visibleDotsCount =
      +this.getAttribute(VISIBLE_DOTS_COUNT_ATTRIBUTE) || 3

    this.sideDotsThreshold = this.visibleDotsCount === 3 ? 1 : 2

    this.track = $el(DOTS_TRACK_SELECTOR, this)
    this.dotWidth = (this.track.lastChild as HTMLElement).offsetWidth

    this.carousel?.embla.on('select', this.handleCarouselSelect)
    this.addListener(this.track, 'click', this.handleDotClick)
  }

  unmountComponent(): void {
    this.carousel?.embla.off('select', this.handleCarouselSelect)
  }

  scrollTrack = (selectedIndex: number) => {
    const scrollPoint =
      selectedIndex < this.sideDotsThreshold + 1
        ? 0
        : selectedIndex > this.dots.length - this.sideDotsThreshold
        ? this.track.offsetWidth
        : (selectedIndex - this.sideDotsThreshold) * this.dotWidth

    this.track.parentElement.scrollTo({
      left: scrollPoint,
      behavior: 'smooth',
    })
  }

  updateDots = (selectedIndex: number) => {
    this.dots.forEach((dot, index, { length }) => {
      dot.classList.toggle(DOT_ACTIVE_CLASS, index === selectedIndex)

      if (index > 0 && index < length - 1) {
        let isPrev: boolean

        if (selectedIndex < this.sideDotsThreshold) {
          isPrev = index === this.visibleDotsCount - 1
        } else if (selectedIndex > length - 1 - this.sideDotsThreshold) {
          isPrev = index === length - this.visibleDotsCount
        } else {
          isPrev =
            selectedIndex - this.sideDotsThreshold === index ||
            selectedIndex + this.sideDotsThreshold === index
        }

        dot.classList.toggle(CAN_SCROLL_CLASS, isPrev)
      }
    })
  }

  handleCarouselSelect = () => {
    const selectedIndex = this.carousel?.embla.selectedScrollSnap()

    this.updateDots(selectedIndex)
    this.scrollTrack(selectedIndex)
    this.activeIndex = selectedIndex
  }

  scrollCarouselToSlide = (index: number): void => {
    if (index !== this.activeIndex) {
      this.carousel?.embla.scrollTo(index)
    }
  }

  handleDotClick = (event: PointerEvent): void => {
    const dot: HTMLElement = (event.target as HTMLElement).closest(DOT_SELECTOR)

    if (dot) {
      this.scrollCarouselToSlide(+dot.dataset.dotIndex)
    }
  }

  get carousel(): CarouselComponent {
    return $elParent(CAROUSEL_SELECTOR, this)
  }

  get dots(): HTMLElement[] {
    return (this._dots = this._dots || [...$list(DOT_SELECTOR, this)])
  }
}
